/**
 * @title product.js: Feature level module
 * @description The module used for the 'product'
 * feature which encapsulates the product page.
 * social object is referenced outside of here by product page.
 * @dependency mathtable.js, navigation.js
 */
define(['product_helper','mathtable','addtocart','compareProducts','social','addMemberNumber','vendor', 'scheduledDeliverable', 'linkMembership', 'membershipValidation', 'imageLightbox', 'modalImageLightbox', 'modalZoomViewer', 'adobeAnalyticsEvents'], 
	function(product_helper, mathtable, addtocart, compareProducts,social,addMemberNumber,vendor, scheduledDeliverable, linkMembership, membershipValidation, imageLightbox, modalImageLightbox, modalZoomViewer, adobeAnalyticsEvents) {
		function init() {
			COSTCO.util.safe(vendor.initProductPage, 'Product.init').call(vendor);
			COSTCO.util.safe(mathtable.init, 'Product.init')();
			COSTCO.util.safe(addtocart.init, 'Product.init').call(addtocart);
			COSTCO.util.safe(compareProducts.init, 'Product.init').call(compareProducts);
			COSTCO.util.safe(product_helper.init, 'Product.init').call(product_helper);
			COSTCO.util.safe(scheduledDeliverable.init, 'Product.init').call(scheduledDeliverable);
			COSTCO.util.safe(linkMembership.init, 'LinkMembership.init').call(linkMembership);
		
			if ($('.shop-all-brand').length > 0) {
				COSTCO.util.responsivePlacement({placement : '.shop-all-brand', content : '.visible-xs-block'});
			}
			
			COSTCO.util.responsivePlacement({placement : '.product-manuals', content : '.visible-xl-block'});
			COSTCO.util.responsivePlacement({placement : '.product-concierge', content : '.visible-xl-block'});
			COSTCO.util.responsivePlacement({placement : '.product-right-banners', content : '.visible-xl-block'});
			
			COSTCO.util.safe(product_helper.openWishListSuccess, 'Product.init').call(product_helper);
			COSTCO.Header.refreshGroceryOrderParams();
			window.reactObj.pickUpQty = $('#pickUpQty').val();
			if($('#isBOPIWItemForMemberInfo').val()=="true" || $('#isShipToWarehouseItem').val()=="1" || $('#isBOPIMItemForMemberInfo').val()=="true"){
				var bopiwMemberInfo = COSTCO.util.getMemberCookie();
				var memberInfoDetails = {"signedIn":bopiwMemberInfo.signedIn};
				window.wioEventBus.publish("memberInfo" , memberInfoDetails);
				window.reactObj.memberInfo=bopiwMemberInfo;
			}
			
			if(COSTCO.util.checkElementById('#liveChatEnabled', 'true')){
				let mList = document.getElementById('chatInlay'),
				observer = new MutationObserver(function mCallback(mutations) {
					  for (let mutation of mutations) {
						    if (mutation.target.id === 'chatInlay') {
						    	 $('#chatInlay').css("z-index","21000");
						    	 $('#zoomViewer').css("transform-style", "preserve-3d");
						    }
						  }
						});

				observer.observe(mList, {
					  childList: true,
					  attributes: true,
					  characterData: true,
					  subtree: true,
					  attributeOldValue: false,
					  characterDataOldValue: true
					});
		    }
			COSTCO.Global.notify('ProductModuleLoaded');			
		}
		

		if(typeof window.COSTCO == 'undefined'){
			window.COSTCO = new Object();
		}
		
		
		if(typeof window.COSTCO.Global == 'undefined')
			document.addEventListener("CostcoGlobalLoaded", init, false);
		else{
			init();
		}
});


// WEBPACK FOOTER //
// ./js/product/product.js